import {Component,Input, ViewChild} from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { PlatformLocation } from '@angular/common';
export interface ConfirmModel {
  title:string;
  message:string;
}
@Component({  
    selector: 'confirm',
    template: `<div class="vertical-alignment-helper"><div class="modal-dialog">
                <div class="modal-content">
         
                   <div class="poupupTitle">
                    
                   </div>
               
                   <div class="modal-body personalizePopup  text-center">
                   <div class="firstPopup">
                     <h3>{{message || 'Are you sure?'}}</h3>
                     <p class="text-center">Select the Interests that you care about and we’ll find you the best deals and offers based on your current location.</p>
                     </div>
                   </div>
                   <div class="modal-footer" style="text-align:center">
                     <button type="button" class="btn btn-default btn-orange text-center" (click)="confirm()">Add Interests</button>
                   </div>
                 </div>
              </div></div>`
})
export class PopupInterestComponent extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel {
  title: string;
  message: string;
  constructor(dialogService: DialogService, location: PlatformLocation) {
    super(dialogService);
      location.onPopState(() => {
     this.close();
    });
  }
  public confirm() {
    // this.result = true;
    this.close();
  }

  


}



// WEBPACK FOOTER //
// ./src/app/users/popup/popup.interest.component.ts